import getLocale from './getLocale'
export default getLocale
